import React, { ReactElement } from 'react';
import CloseIcon from 'components/Icons/CloseIcon';
import { Button } from 'components/Button';

import { BaseProps } from './BaseContent.types';
import styles from './BaseContent.module.scss';

function BaseContent({
  children,
  onClose,
  onPrimaryClick,
  primaryActionText,
  secondaryAction,
}: BaseProps): ReactElement {
  return (
    <div className={styles.dialog} role="dialog">
      <button
        type="button"
        data-testid="ModalClose"
        className={styles.closeButton}
        onClick={onClose}>
        <CloseIcon />
      </button>
      <div className={styles.dialogContent}>{children}</div>
      <Button block data-testid="modal-primary-button" onClick={onPrimaryClick}>
        {primaryActionText}
      </Button>
      {secondaryAction && secondaryAction}
    </div>
  );
}

export { BaseContent };
